import React from 'react';

const Mathematics = () => {
  return (
    <div>
      Mathematics
      Mathematics
    </div>
  );
}

export default Mathematics;
